var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-step",
      class: [
        _vm.currentStatus ? `v-step--${_vm.currentStatus}` : "",
        { "v-step--center": _vm.alignCenter },
      ],
      style: _vm.stepStyle,
    },
    [
      _c(
        "div",
        { staticClass: "v-step__icon" },
        [
          _vm._t("icon", function () {
            return [
              _vm.currentIcon
                ? _c("i", { class: [_vm.currentIcon, "is-icon"] })
                : _c("i", { class: ["is-text"] }, [
                    _vm._v(_vm._s(_vm.index + 1)),
                  ]),
            ]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "v-step__content" }, [
        _c(
          "div",
          { staticClass: "v-step__title" },
          [
            _vm._t("title", function () {
              return [
                _c("span", { staticClass: "v-step__title--default" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
              ]
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "v-step__description" },
          [
            _vm._t("description", function () {
              return [
                _vm.description
                  ? _c(
                      "span",
                      { staticClass: "v-step__description--default" },
                      [_vm._v(" " + _vm._s(_vm.description) + " ")]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }